import $ from 'jquery';

const hasTargeting = (categories = []) =>
    Array.isArray(categories) && categories.includes('targeting');

const hasTargetingConsent = () => {
    try {
        if (!window.CookieScript || !window.CookieScript.instance) {
            return false;
        }

        const state = window.CookieScript.instance.currentState();
        return hasTargeting(state && state.categories);
    } catch (e) {
        return false;
    }
};

const reveal = ($el) => {
    if ($el.hasClass('js-state-embed-visible')) {
        return;
    }

    const content = $el.data('content');
    if (!content) {
        return;
    }

    $el.html(content);
    $el.addClass('js-state-embed-visible');
};

const revealAll = () => {
    $('.js-embed-message').each((_, el) => reveal($(el)));
};

const revealIfTargeting = (categories) => {
    if (hasTargeting(categories) || hasTargetingConsent()) {
        revealAll();
    }
};

const EmbedMessage = (el) => {
    const $el = $(el);
    $el.find('.js-embed-button').on('click', () => reveal($el));
};

const bindConsentListeners = () => {
    window.addEventListener('CookieScriptAcceptAll', () => revealIfTargeting());
    window.addEventListener('CookieScriptAccept', (e) => {
        const categories = e.detail && e.detail.categories;
        revealIfTargeting(categories);
    });
    window.addEventListener('CookieScriptCategory-targeting', revealAll);
    window.addEventListener('CookieScriptLoaded', () => {
        if (hasTargetingConsent()) {
            revealAll();
        }
    });

    // CookieScript may already be ready before this listener is attached
    if (hasTargetingConsent()) {
        revealAll();
    }
};

export { bindConsentListeners };
export default EmbedMessage;
